import { ApiManager } from '../core/api-manager';

/**
 * Assegnazione di una palazzina al suo condominio
 * (api/custom_classes/PalazzinaEngine.php).
 *
 * Non passa da DataManager perche' `idUserGroup` la CRUD del framework non lo
 * accetta ne' in creazione ne' in modifica: lo timbra da sola con il gruppo di
 * chi scrive. Per l'amministratore globale, che di condomini ne ha davanti
 * piu' d'uno, quel timbro e' sempre sbagliato.
 *
 * Gli appartamenti della palazzina seguono: la stessa chiamata, a condominio
 * invariato, riallinea quelli appena creati.
 */
async function assegnaPalazzina(idPalazzina, idUserGroup) {
    let body = {
        idPalazzina: idPalazzina,
        idUserGroup: idUserGroup
    }
    let response = await ApiManager.sendAuthenticatedRequest('/custom/assegna_palazzina', body)
    return response;
}


export const PalazzineManager = {
    assegnaPalazzina: assegnaPalazzina
};
